@if (!printMode) {
  <lib-validation-problems [saving$]="saving$"></lib-validation-problems>
}

@if (uiConfiguration.amendmentConfiguration?.showChangeText) {
  <div>
    <h3>{{ 'orders.changeText' | transloco }}</h3>
    <lib-change-text></lib-change-text>
  </div>
}

@if (uiConfiguration.hasReferenceRegistrationInformation) {
  <div>
    <h3>{{ 'common.labels.existingRegistrationDetails' | transloco }}</h3>
    <lib-existing-registration-details
      [uiConfiguration]="uiConfiguration.referenceRegistrationInformationUIConfiguration!">
    </lib-existing-registration-details>
  </div>
}

@if (uiConfiguration.hasLienDetails) {
  <h3>{{ 'common.labels.typeDetails' | transloco: { type: (order.orderTypeID | enumLabel:'orderType':order.orderType.name) } }}</h3>
}
@if (uiConfiguration.hasLienDetails) {
  <div class="flex-item-no-padding">
    <lib-lien-details [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!"></lib-lien-details>
  </div>
}
@if (isDischarge() || isHistorical()) {
  <lib-lien-results [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!"
    [results]="$safeNavigationMigration(order.lien?.registrationResults?.at(0))"
  class="flex-item"></lib-lien-results>
}

@if (uiConfiguration.hasDischargeDetails &&
  uiConfiguration.dischargeDetailsConfiguration &&
  uiConfiguration.dischargeDetailsConfiguration.showAny) {
  <div>
    <h3>{{ 'orders.dischargeDetails' | transloco }}</h3>
    <div class="flex-item-no-padding">
      <lib-discharge-details [order]="order"
      [uiConfiguration]="uiConfiguration.dischargeDetailsConfiguration"></lib-discharge-details>
    </div>
  </div>
}

@if (uiConfiguration?.hasSecuredParties) {
  <div>
    <h3>{{ 'common.labels.securedParties' | transloco }}</h3>
    <lib-parties-list [order]="order" [observableParties$]="securedParties" [isEditable]="false"
      [uiConfiguration]="uiConfiguration!.securedPartiesConfiguration!">
    </lib-parties-list>
  </div>
}

@if (uiConfiguration?.hasAssignors) {
  <div>
    <h3>{{ 'common.labels.assignors' | transloco }}</h3>
    <lib-parties-list [order]="order" [observableParties$]="assignors" [isEditable]="false"
      [uiConfiguration]="uiConfiguration!.assignorsConfiguration!">
    </lib-parties-list>
  </div>
}

@if (uiConfiguration?.hasAssignees) {
  <div>
    <h3>{{ 'common.labels.assignees' | transloco }}</h3>
    <lib-parties-list [order]="order" [observableParties$]="assignees" [isEditable]="false"
      [uiConfiguration]="uiConfiguration!.assigneesConfiguration!">
    </lib-parties-list>
  </div>
}

@if (uiConfiguration?.hasDebtors) {
  <div>
    <h3>{{ 'orders.debtors' | transloco }}</h3>
    <lib-parties-list partyTypeTitle="Debtor" [order]="order" [observableParties$]="debtors" [isEditable]="false"
      [uiConfiguration]="uiConfiguration!.debtorsConfiguration!">
    </lib-parties-list>
  </div>
}

@if (uiConfiguration?.hasDealers) {
  <div>
    <h3>{{ 'common.labels.dealers' | transloco }}</h3>
    <lib-parties-list partyTypeTitle="Dealer" [order]="order" [observableParties$]="dealers" [isEditable]="false"
      [uiConfiguration]="uiConfiguration!.dealersConfiguration!">
    </lib-parties-list>
  </div>
}

@if (uiConfiguration?.hasRegisteringAgents) {
  <div>
    <h3>{{ 'common.labels.registeringAgents' | transloco }}</h3>
    <lib-parties-list partyTypeTitle="Registering Agent" [order]="order" [observableParties$]="registeringAgents"
      [isEditable]="false" [uiConfiguration]="uiConfiguration!.registeringAgentsConfiguration!">
    </lib-parties-list>
  </div>
}

@if (uiConfiguration?.collateralConfiguration?.hasGeneralCollateral) {
  <div>
    <h3>{{ 'common.labels.generalCollateral' | transloco }}</h3>
    <lib-general-collateral [uiConfiguration]="$safeNavigationMigration(uiConfiguration.collateralConfiguration?.generalCollateralConfiguration)"></lib-general-collateral>
  </div>
}

@if (uiConfiguration?.collateralConfiguration?.hasAssets) {
  <div>
    <h3>{{ 'common.labels.assets' | transloco }}</h3>
    <lib-asset-list [order]="order" [isEditable]="false"
      [uiConfiguration]="uiConfiguration!.collateralConfiguration!.assetConfiguration!">
    </lib-asset-list>
  </div>
}